import ImageGeneration from './ImageGeneration'

export default ImageGeneration
